module.exports = __webpack_public_path__ + "static/img/8.26a7750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/8.png
// module id = kNEO
// module chunks = 0